import RequestService from '../../../services/request-service';
import FixtureMenuModel from './model-fixture-menu';
import DateFilterService from '../../../services/date-filter-service';

/**
 * Service for getting fixture menu
 */
export default class FixtureMenuService extends RequestService {
  /**
   * Class constructor method
   * @param dateFilter filtering records by time period
   */
  constructor(dateFilter) {
    super();
    this.method = 'get';
    this.endpoint = this.$config.endpoints.fixtureMenu;
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      LoadPeriod: DateFilterService.parseDateFilter(dateFilter),
      // eslint-disable-next-line no-undef
      culture: Culture,
      // TimeOffset: DateFilterService.utcTimeOffset(),
    };
    this.headers = null;
  }

  /**
   * Recursive function for creating the sports tree
   * @param data received pure API data
   * @param {{}} [categoryMap] - optional object to fill with category data only
   * @return array of FixtureMenuModel
   */
  fillDate(data, categoryMap) {
    let tmpFixtureMenu = [];
    data.forEach((el) => {
      let tmpFixtureCat = new FixtureMenuModel(el);
      if (el.i) {
        tmpFixtureCat.items = this.fillDate(el.i, categoryMap);
      }
      if (categoryMap && tmpFixtureCat.cType === 1) {
        categoryMap[tmpFixtureCat.id] = {
          iClass: tmpFixtureCat.class
        };
      }
      tmpFixtureMenu.push(tmpFixtureCat);
    });
    return tmpFixtureMenu;
  }
}
